module.exports = __webpack_public_path__ + "images/slide3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide3.png
// module id = 1136
// module chunks = 0